import React from 'react'
import LogoImg from '../../../assets/svg/logo.svg'
import SingleQuoteImg from '../../../assets/img/single-quote.png'
import '../../../styles/components/common/_LeftImageComponent.scss'
const LeftImageComponent = ({ image, quote, quoteby }) => (
  <div className="left-image-component-container"
    style={{
        backgroundImage: `url(${image})`
    }}>
        <div className="logo">
            <img src={LogoImg} alt="logo" />
        </div>
        <div className="left-image-component-inner-container">
            <div> <img src={SingleQuoteImg}/><img src={SingleQuoteImg} style={{marginLeft:'2px'}}/> </div>
            <div className="left-image-component-text"
            style={{marginTop:"10px"}}>
                <h2 style={{color:'white', fontSize:'40px'}}> {quote} </h2>
            </div>
            <div className="left-image-component-quoteby">
                <p
                    style={{
                        color:'white',
                        marginTop:'25px'
                    }}>
                    {quoteby}
                </p>
            </div>
        </div>
  </div>
)

export default LeftImageComponent
